import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Subscription } from 'rxjs';
import { PIN_STATE } from '../pin-state';

@Component({
  selector: 'act-pin',
  templateUrl: './pin.component.html',
  styleUrls: ['./pin.component.scss']
})
export class PinComponent implements OnInit, OnChanges {

  public elementId = 'pin';
  public pinInputForm: FormGroup;
  public lang: string;

  public PIN_STATE = PIN_STATE;

  private langSubscription: Subscription;

  @Input() state: string;
  @Input() isLoading = false;
  @Input() errorMessage: string;

  @Output() clickResentOTP: EventEmitter<any> = new EventEmitter();
  @Output() resetError: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private appConfigService: AppConfigService
  ) {
    this.initialForm();

  }

  ngOnInit(): void {
    this.subscribeLanguageChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const state = changes['state']
    if (state && state.currentValue) {
      this.pinInputForm.reset();
      this.focusInput(0);
    }
  }

  subscribeLanguageChanges(): void {
    this.lang = this.appConfigService.getLanguage();
    this.langSubscription && this.langSubscription.unsubscribe();
    this.langSubscription = this.appConfigService.getLanguageObs().subscribe(lang => {
      this.lang = lang;
    });
  }

  get pinControls() {
    return Object.keys(this.pinInputForm.controls);
  }

  initialForm(): void {
    this.pinInputForm = this.fb.group({
      0: ['', Validators.required],
      1: ['', Validators.required],
      2: ['', Validators.required],
      3: ['', Validators.required],
      4: ['', Validators.required],
      5: ['', Validators.required],
    });
    this.pinInputForm.valueChanges.subscribe(() => {
      this.resetError.emit();
    });
  }

  onPinInput(event: Event, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length === 1 && index < 5) {
      this.focusInput(index + 1)
    } else if (inputElement.value.length > 1) {
      const value = inputElement.value.slice(0, 1);
      inputElement.value = value;
      this.pinInputForm.controls[index].setValue(value);
    }
  }

  onKeydown(event: KeyboardEvent, index: number): void {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Meta', 'Control', 'v'];
    const isNumeric = /^[0-9]$/i.test(event.key);

    if (!isNumeric && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }

    const control = this.pinInputForm.get(index.toString());
    const value = control ? control.value : '';

    if (event.key === 'Backspace' && value !== 0 && !value && index > 0) {
      this.focusInput(index - 1)
    }
  }

  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData ? event.clipboardData.getData('text') : '';

    if (clipboardData) {
      const pastedPin = clipboardData.replace(/[^0-9]/g, '');
      const pinChars = pastedPin.split('');

      pinChars.forEach((char, index) => {
        const control = this.pinInputForm.get(index.toString());
        if (control) {
          control.setValue(char);
        }
      });

      event.preventDefault();
    }
  }

  get rawPin() {
    return Object.keys(this.pinInputForm.value).map(key => this.pinInputForm.value[key]).join('');
  }

  get pinInputFormControls() {
    return this.pinInputForm;
  }

  focusInput(index) {
    const input = document.querySelectorAll(`#${this.elementId}-form input`)[index] as HTMLInputElement;
      if (input) {
        input.focus();
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-pin/pin/pin.component.ts